import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SecurityTiles() {
  const { t } = useTranslation('common');

  return (
    <div className="mt-4 grid grid-cols-3 gap-4 text-center text-sm text-gray-600">
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <div className="font-semibold mb-1">{t('securityTiles.sslTitle')}</div>
        <div>{t('securityTiles.sslDescription')}</div>
      </div>
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <div className="font-semibold mb-1">{t('securityTiles.privacyTitle')}</div>
        <div>{t('securityTiles.privacyDescription')}</div>
      </div>
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <div className="font-semibold mb-1">{t('securityTiles.speedTitle')}</div>
        <div>{t('securityTiles.speedDescription')}</div>
      </div>
    </div>
  );
}
